export default __webpack_public_path__ + "static/image 1-327b6e1cc96c64bbd7a74e732dc65b0a.png";